import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getProductCatalog } from "../../services/axios";

export const ProductCatalog = () => {
  let history = useHistory();

  const [products, setProducts] = useState([]);

  useEffect(() => {
    const query = async () => {
      const prodQuery = await getProductCatalog();
      setProducts(prodQuery);
    };
    query();
  }, []);

  const goToCreateNew = () => {
    history.push({
      pathname: `/product-catalog/create`,
    });
  };

  const goToProduct = (sku) => {
    history.push({
      pathname: `/product-catalog/${sku}`,
    });
  };

  return (
    <div className="w-full">
      <button
        onClick={() => goToCreateNew()}
        className="m-4 px-4 py-2 underline"
      >
        Create New
      </button>
      <div className="w-full grid grid-flow-row grid-cols-5 justify-center items-center">
        {products && products.length >= 1 ? (
          products?.map(function (product, index) {
            return (
              <button key={index} onClick={() => goToProduct(product.sku)}>
                <div className="border p-16 m-4 flex flex-col" key={index}>
                  <div className="flex flex-col justify-center items-center">
                    <div className="w-64 h-64">
                      <img
                        className="w-64 h-64 object-fill"
                        alt=""
                        src={product.image_url}
                      />
                    </div>
                    <div className="mt-4">
                      <p>
                        {product.brand} - {product.model} - {product.sku}
                      </p>
                    </div>
                  </div>
                </div>
              </button>
            );
          })
        ) : (
          <div>none</div>
        )}
      </div>
    </div>
  );
};
